import { defineMessages } from "react-intl";

export const messages = defineMessages({
  productType: {
    id: "w+3Q3e",
    defaultMessage: "Product type",
    description: "input label",
  },
  selectProductType: {
    id: "/yJJvI",
    defaultMessage: "Select a product type",
    description: "dialog header",
  },
});
